import React, { Component } from 'react'
import ViewInvoice from './ViewInvoice'
import Invoices from '../../../../api/Sales/Invoices'
import { withRouter } from 'react-router-dom'
import { compose, withState } from 'recompose'
import { message } from 'antd'
import { assign, get, omit, pick, set } from 'lodash'
import {
  dateFormat,
  dateVal,
  execute,
  idMaker,
  moneyInline,
  normalizeDateTimeToDate,
  numVal,
  strVal,
  checkForm as _checkForm,
} from '../../../../modules/Utils'
import Documents from '../../../../api/Documents'
import Templates from '../../../../api/Templates'
import Email from '../../../../api/Email'

class ViewInvoiceCont extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.state = {
      fetching: false,
      invoice: {},
      actions: [],
    }
    this.api = new Invoices()
    this.docsApi = new Documents()
    this.formRef = React.createRef()
    this.billLineFormRef = React.createRef()
    this.ids = idMaker()
  }

  componentDidMount() {
    this.fetch()
    this.fetchLines()
  }

  handleOps = async (operation, invoice) => {
    const { confirm, submit, revise, cancel, unCancel, remove, reject, pay } = this.api
    const { history } = this.props
    switch (operation) {
      case 'revise':
        await execute(this, revise.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'update':
        this.onEdit()
        break
      case 'submit':
        await execute(this, submit.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'cancel':
        await execute(this, cancel.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'unCancel':
        await execute(this, unCancel.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'remove':
        try {
          await execute(this, remove.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
          history.replace({
            pathname: `/clients/invoices/`,
            hash: 'contracts',
          })
        } catch (e) {}
        break
      case 'confirm':
        await execute(this, confirm.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'reject':
        await execute(this, reject.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'pay':
        await execute(this, pay.bind(this, pick(invoice, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
    }
  }
  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const invoice = await this.api.get(this.key)
      this.setState({
        invoice,
      })
      const actions = await this.docsApi.actions('invoices', invoice.status)
      this.setState({
        fetching: false,
        actions,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }
  fetchLines = async () => {
    try {
      this.props.fetchLines(true)
      const lines = await this.api.lines.list(this.key)
      this.props.fetchLines(false)
      this.setState({
        lines,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.props.fetchLines(false)
    }
  }
  onEdit = () => {
    this.setState({
      visible: true,
      type: 'edit',
    })
  }
  onCancel = () => {
    this.setState({
      visible: false,
    })
    this.formRef.current.resetFields()
  }
  update = async () => {
    await this.checkForm()
    try {
      let { invoice, values } = this.state
      this.setState({
        submitting: true,
      })
      const newInvoices = await this.api.update(
        omit(assign(values, pick(invoice, ['_id', '_rev', '_key'])), [
          'transaction',
          'code',
          'status',
          '_history',
          'company',
          'revision',
          'allocated',
        ])
      )
      this.setState({
        submitting: false,
        invoice: newInvoices,
      })
      message.success('Updated')
      this.onCancel()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  confirm = async () => {
    try {
      let { invoice } = this.state
      this.setState({
        submitting: true,
      })
      await this.api.confirm(pick(invoice, ['_key', '_id', '_rev']))
      this.setState({
        submitting: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          normalizeDateTimeToDate(values, 'date')
          normalizeDateTimeToDate(values, 'dueDate')
          normalizeDateTimeToDate(values, 'billDate')
          this.setState({
            values,
          })
          res(true)
        }
      })
    })
  }
  handleChange = (value, _key, column) => {
    const newData = [...this.state.lines]
    const target = newData.find((item) => _key === item._key)
    if (target) {
      if (column === 'tax.type') {
        value === 'zer' && set(target, 'tax.rate', 0)
      }
      set(target, column, value)
      this.setState({ lines: newData })
    }
  }
  onShowBillLine = (billLine = {}, billLineModalType = 'new') => {
    this.setState({
      visibleBillLine: true,
      billLine,
      billLineModalType,
    })
  }
  onCancelBillLine = () => {
    this.setState({
      visibleBillLine: false,
      billLine: {},
    })
  }
  removeLine = async () => {
    try {
      this.setState({
        removingLine: true,
      })
      const { billLine } = this.state
      await this.api.lines.remove(pick(billLine, ['_id', '_rev', '_key']))
      this.setState({
        removingLine: false,
      })
      this.onCancelBillLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        removingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  addLine = async () => {
    let billLine = await _checkForm(this.billLineFormRef)
    try {
      this.setState({
        submittingLine: true,
      })
      await this.api.lines.add(billLine)
      this.setState({
        submittingLine: false,
      })
      this.onCancelBillLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        submittingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  updateLine = async () => {
    let billLine = await _checkForm(this.billLineFormRef)
    billLine = { ...billLine, ...pick(this.state.billLine, ['_id', '_rev', '_key']) }
    try {
      this.setState({
        submittingLine: true,
      })
      const { line, invoice } = await this.api.lines.update(omit(billLine, ['invoiced', 'amount']))
      this.setState((prevState) => ({
        submittingLine: false,
        invoice,
        lines: prevState.lines.map((l) => (l._id === line._id ? line : l)),
      }))
      message.success('Updated')
      this.onCancelBillLine()
    } catch (error) {
      this.setState({
        submittingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }

  checkBillLineFrom = async () => {
    return new Promise((res, rej) => {
      this.billLineFormRef.current.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.error(err)
          res({
            ...pick(this.state.billLine, ['_id', '_rev', '_key']),
            ...values,
          })
        }
      })
    })
  }
  syncClient = async () => {
    try {
      const { invoice } = this.state
      this.setState({
        fetching: true,
      })
      await this.api.syncClient(pick(invoice, ['_id', '_rev', '_key']))
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  syncOrder = async () => {
    try {
      const { invoice } = this.state
      this.setState({
        fetching: true,
      })
      await this.api.syncOrder(pick(invoice, ['_id', '_rev', '_key']))
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }

  templateApi = new Templates()
  emailApi = new Email()

  showEmail = async () => {
    const selection = [this.state.invoice]
    if (selection.find((s) => !['Confirmed', 'Paid'].includes(s.status))) {
      message.error(`Can't email non confirmed invoices`)
      return
    }

    try {
      this.setState({
        fetchingEmailTemplate: true,
      })
      let lines = selection.map((i) => ({
        date: dateFormat(dateVal(i, 'date')),
        ref: strVal(i, 'cpo.no'),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        type: strVal(i, 'type'),
        amount: moneyInline(numVal(i, 'subTotal.gross'), strVal(i, 'currency')),
        dueDate: dateFormat(dateVal(i, 'dueDate')),
      }))

      const invoiceTemplate = await this.templateApi.read(
        strVal(selection, '0.company._id').replace('members/', ''),
        'invoice'
      )
      const emailDetails = get(invoiceTemplate, 'email') || {}
      const data = await this.emailApi.invoiceTemplate({
        receiver: get(selection, '0.payableRep.fn'),
        companyRep: get(selection, '0.companyRep.fn'),
        lines: lines,
        ...emailDetails,
      })
      const filesList = await this.api.files(selection.map((s) => s._id))
      const filesMapped = filesList.map((f) => f.uuid)
      this.setState({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        emailLines: selection,
        emailDetails: {
          to: get(selection, '0.payableRep.email.label'),
          cc: get(selection, '0.companyRep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: get(selection, '0.issuance.subject') ? get(selection, '0.issuance.subject') : 'INVOICE ISSUANCE - * Auto-generated Email *',
          attachments: filesMapped,
        },
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetchingEmailTemplate: false,
      })
    }
  }
  onCancelEmail = () => {
    this.setState({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }

  render() {
    return (
      <ViewInvoice
        {...this.state}
        {...pick(this.props, ['fetchingLines'])}
        {...pick(this, [
          'fetchLines',
          'onEdit',
          'handleOps',
          'onCancel',
          'update',
          'formRef',
          'fetch',
          'syncClient',
          'syncOrder',
          'removeLine',
          'addLine',
          'updateLine',
          'handleChange',
          'onShowBillLine',
          'onCancelBillLine',
          'billLineFormRef',
          'showEmail',
          'onCancelEmail',
        ])}
      />
    )
  }
}

ViewInvoiceCont.propTypes = {}
ViewInvoiceCont.defaultProps = {}

export default compose(withRouter, withState('fetchingLines', 'fetchLines', false))(ViewInvoiceCont)
